import { Button, DownloadIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { useConfirm } from "melco-shared-logic";
import { useDownloadAllUsersReport } from "../../hooks/reports/useDownloadAllUsersReport";

type AllUserReportsDownloadButtonProps = {
  filename?: string;
  productCode?: string;
  dateRange?: any;
  disabled?: boolean;
};

export const AllUserReportsDownloadButton: React.FC<
  AllUserReportsDownloadButtonProps
> = ({ filename, productCode, dateRange, disabled }) => {
  const { t } = useTranslation();
  const [allUserReports, isLoading] = useDownloadAllUsersReport(
    productCode ?? "",
    dateRange
  );

  const confirmDownload = useConfirm(
    async () => {
      const blob = await allUserReports();

      if (blob) {
        saveAs(blob, filename + ".csv");
      } else {
        console.log("Not a blob");
      }
    },
    {
      translationPrefix: "reports.actions.download",
    }
  );

  const downloadLogic = async () => {
    confirmDownload();
  };

  return (
    <Button
      key="report-download"
      icon={<DownloadIcon />}
      onClick={downloadLogic}
      loading={isLoading}
      disabled={disabled}
    >
      {t("reports.actions.download.button")}
    </Button>
  );
};
